import { IconType } from 'react-icons';
import { toast } from 'react-toastify';
import ReactIcon from '../../components/ReactIcon';
import { DateUtils } from '../../helpers/dateUtils';
import { isUndecidedDate } from '../Calendar';

interface ToastCartProps {
    typeAction: 'remove' | 'add' | 'warn' | 'edit' | 'error';
    hour?: string;
    title?: string;
    date?: Date;
    Icon: IconType;
    message?: string;
}

export const ToastCart = ({
    typeAction,
    date = new Date(),
    hour,
    title = '',
    Icon,
    message,
}: ToastCartProps) => {
    const undecidedDate = isUndecidedDate(date);
    const dateMessage = undecidedDate
        ? { prefix: 'para uma', dateText: 'data ainda não definida' }
        : { prefix: 'do dia', dateText: DateUtils.formatToDayMonthYear(date) };
    switch (typeAction) {
        case 'remove':
            toast.success(
                ({ data: { title } }) => {
                    return (
                        <>
                            <strong>{title}</strong> {dateMessage.prefix}
                            <strong> {dateMessage.dateText}</strong>
                            {hour && !undecidedDate && (
                                <>
                                    {' '}
                                    às
                                    <strong> {hour}</strong>
                                </>
                            )}{' '}
                            foi removido com sucesso!
                        </>
                    );
                },
                {
                    icon: (
                        <ReactIcon
                            Icon={Icon}
                            size={'1.5rem'}
                            fill="#22C55E"
                            color="white"
                        />
                    ),
                    data: {
                        title: title,
                        date: DateUtils.formatSingleDate(date),
                    },
                }
            );
            break;

        case 'add':
            toast.success(
                ({ data: { title } }) => {
                    return (
                        <>
                            <strong>{title}</strong> {dateMessage.prefix}
                            <strong> {dateMessage.dateText}</strong>
                            {hour && !undecidedDate && (
                                <>
                                    {' '}
                                    às
                                    <strong> {hour}</strong>
                                </>
                            )}{' '}
                            foi adicionado com sucesso!
                        </>
                    );
                },
                {
                    icon: (
                        <ReactIcon
                            Icon={Icon}
                            size={'1.5rem'}
                            fill="#22C55E"
                            color="white"
                        />
                    ),
                    data: {
                        title: title,
                        date: DateUtils.formatSingleDate(date),
                    },
                }
            );
            break;
        case 'warn':
            toast.warn((typeof message !== 'undefined' && message) ? message : 'Operação não permitida', {
                icon: (
                    <ReactIcon
                        Icon={Icon}
                        size={'1.5rem'}
                        fill="#c58c22"
                        color="white"
                    />
                ),
            });
            break;

        case 'edit':
            toast.success('O produto foi editado com sucesso', {
                icon: (
                    <ReactIcon
                        Icon={Icon}
                        size={'1.5rem'}
                        fill="#22C55E"
                        color="white"
                    />
                ),
            });
            break;

        case 'error':
            toast.error('Erro ao executar a operação', {
                icon: (
                    <ReactIcon
                        Icon={Icon}
                        size={'1.5rem'}
                        fill="#E11D48"
                        color="white"
                    />
                ),
            });
            break;

        default:
            break;
    }
};
